export enum GoogleSiteListSortNameEnum {
  NAME_ASC = 'Name: A-Z',
  NAME_DESC = 'Name: Z-A',
  LAST_MODIFIED_DATE_ASC = 'Last Modified Date: Asc',
  LAST_MODIFIED_DATE_DESC = 'Last Modified Date: Desc',
}
